/* ============================================================
   Maze Collection — theme JS
   Mobile nav toggle, mega-menu (touch/keyboard), scroll reveal.
   ============================================================ */
(function () {
  'use strict';

  /* ── mobile nav panel ── */
  var menuBtn = document.getElementById('menuBtn');
  var mobile = document.getElementById('mobileNav');
  if (menuBtn && mobile) {
    menuBtn.addEventListener('click', function () {
      var open = mobile.classList.toggle('open');
      menuBtn.setAttribute('aria-expanded', String(open));
    });
  }

  /* ── mega menus: hover is CSS; this adds click/tap + keyboard ── */
  var navItems = [].slice.call(document.querySelectorAll('.nav-item.has-mega'));
  navItems.forEach(function (item) {
    var link = item.querySelector('.nav-link');
    if (!link) return;
    link.addEventListener('click', function (e) {
      // Only intercept when the dropdown isn't just a plain link target
      if (window.matchMedia('(hover: none)').matches) {
        e.preventDefault();
        var isOpen = item.classList.toggle('open');
        navItems.forEach(function (other) { if (other !== item) other.classList.remove('open'); });
        link.setAttribute('aria-expanded', String(isOpen));
      }
    });
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.nav-item.has-mega')) {
      navItems.forEach(function (item) {
        item.classList.remove('open');
        var l = item.querySelector('.nav-link');
        if (l) l.setAttribute('aria-expanded', 'false');
      });
    }
  });

  /* ── scroll reveal ── */
  var reveals = [].slice.call(document.querySelectorAll('.rv'));
  if (!reveals.length) return;
  if (!('IntersectionObserver' in window)) {
    reveals.forEach(function (el) { el.classList.add('on'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) { en.target.classList.add('on'); io.unobserve(en.target); }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
  reveals.forEach(function (el) { io.observe(el); });
})();

/* ── tile studio loops ──
      .tile-vid--hover  → play on hover (collection: close-up still by default,
                          video reveals on hover, resets to the still on leave).
      .tile-vid         → viewport-autoplay (rec cards), preload="none" until seen. */
(function () {
  var all = [].slice.call(document.querySelectorAll('.tile-vid'));
  if (!all.length) return;
  function play(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }

  var hover = all.filter(function (v) { return v.classList.contains('tile-vid--hover'); });
  hover.forEach(function (v) {
    var well = v.closest('.well') || v.parentNode;
    var area = (well && well.closest('a')) || well;
    if (!area) return;
    area.addEventListener('mouseenter', function () { if (v.preload === 'none') v.preload = 'auto'; v.classList.add('is-playing'); play(v); });
    area.addEventListener('mouseleave', function () { v.classList.remove('is-playing'); v.pause(); try { v.currentTime = 0; } catch (e) {} });
  });

  var auto = all.filter(function (v) { return !v.classList.contains('tile-vid--hover'); });
  if (auto.length) {
    if (!('IntersectionObserver' in window)) { auto.forEach(play); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) { if (v.preload === 'none') v.preload = 'auto'; play(v); }
        else { v.pause(); }
      });
    }, { threshold: 0.25 });
    auto.forEach(function (v) { io.observe(v); });
  }
})();
